import _ from 'lodash';
import {generateError} from '../validations/errors';
import reporter from '../reporter';

import * as Utils from '../../ui/Utils';
import {isNilOrEmptyString} from '../utils';

const PERMITTED_KEYS = ['label', 'value'];

function getOptionsFromFull() {
    return Utils.getFullDataWithOverrides(this, 'options').map((option) => ({
        label: option.label,
        value: option.value
    }));
}

function getOptionsFromFullWithChecked() {
    return Utils.getFullDataWithOverrides(this, 'options').map((option) => ({
        label: option.label,
        value: option.value,
        checked: !!option.checked
    }));
}

const emptyStringIfNotInOptions = (options, value) => {
    return _.some(options, {value}) ? value : '';
};

const isValidOption = (option) => {
    const optionPermittedKeys = _.pick(option, PERMITTED_KEYS);
    const optionProperties = _.values(optionPermittedKeys);
    const everyPropertyIsNilOrEmpty = _.every(optionProperties, (prop) => isNilOrEmptyString(prop));
    const isValidEmptyOption = _.every(PERMITTED_KEYS, (key) => optionPermittedKeys[key] === '');

    return !_.isEmpty(optionPermittedKeys) &&
        !everyPropertyIsNilOrEmpty ||
        isValidEmptyOption;
};

const optionsToDisplay = (options) => {
    return _.filter(options, (option) => isValidOption(option));
};

const validateOption = (option, index, propertyName) => {
    if (!isValidOption(option)) {
        reporter.reportSdkWarning(generateError.warning_invalid_option({
            propertyName,
            index,
            wrongValue: option
        }));
    }
    return true;
};

export {
    getOptionsFromFull,
    getOptionsFromFullWithChecked,
    emptyStringIfNotInOptions,
    optionsToDisplay,
    validateOption
};
